import './Toast.less';

export const prefix = 'oc-c-toast';

export { default } from './Toast';